<template>
	<div class='my_back'>
		<!-- <a-row>
			<a-col :span='22'>
				<a-row>
					<a-col :span='8' v-for='(item,ind) in tabledata' :key='ind'>
						<a-row>
							<a-col :span='6'>
								<span class=' warp-titlesui'>{{item.name}}</span>
							</a-col>
							<a-col :span='6'>
								<span class='warp-font'>{{item.num}}</span>
							</a-col>
							<a-col :span='6'>
								<span class='dingace'>
								<img v-if='item.static' style="width: 1rem;" :src="require('@/image/simu/down.png')" alt="">
								{{item.downnum}}</span>
							</a-col>
							<a-col :span='6'>
								<span class='dingace'>{{item.zero}}</span>
							</a-col>
						</a-row>
					</a-col>
				</a-row>
			</a-col>
			<a-col :span='2'>
				<div style="color: #00ff06;text-align: right;font-size: 1.1rem !important;">
					{{from.time}}
				</div>
				<div style="color: #dca606;text-align: right;font-size: 1.1rem !important;">
					{{from.name}}
				</div>
			</a-col>
		</a-row> -->
		<div><img :src="logoimg" alt="" style="width: 11rem;"></div>
		<div style="float: right;margin-top: .5rem;">
			<div v-for='(item,ind) in imglist'  class='morediv' >
				<a-popover  placement="bottom" :destroyTooltipOnHide="true" trigger="hover"
					 :overlayStyle="{width:item.widths}"
					:getPopupContainer="triggerNode => {return triggerNode.parentNode;}">
					<template slot="content">
						<div style="font-size: .7rem;">{{item.name}}</div>
						</template>
					<img :src="item.imgurl" alt="" style="width: 1.3rem;margin-right: 1.6rem;cursor:pointer" @click='handadmin(ind)'>
				   </a-popover>
			</div>
			 <a-popover :visible="isshow" placement="bottomRight" :destroyTooltipOnHide="true" trigger="click"
			 	@visibleChange="shEvent()" :overlayStyle="{width:'calc(15rem + 22px)'}"
			 	:getPopupContainer="triggerNode => {return triggerNode.parentNode;}">
				<template slot="content">
					<div class="tableBzView">
						<div class="tableBzViewTitle" style="font-size: .8rem;font-weight: 600;color: #000000;">歡迎，{{form.realname}}</div>
						<div class="tableBzViewList">
							<a-collapse style="background-color:#fcfcfc;" expandIconPosition="right" 
							:accordion="true" :bordered="false">
									<div style="font-weight: 600;font-size: .8rem;color: #000000;">查看我的個人資料</div>
									<div style="font-size: .5rem;">QMIS SECURITIES LIMITED</div>
									<div
										style="margin-bottom: 0.3rem;border-bottom:1px solid #d8d8d8;width: 100%;height: 1px;">
									</div>
									<span style="font-size: .8rem;">最近登入 : </span>
									<span style="font-size: .71rem;">{{form.lastlogintime}}</span>
									<div style="margin-left: 3.9rem;font-size: .71rem;">[QMIS NET]</div>
									<div style="margin: .2rem 0 .3rem;">
									<span style="font-size: .8rem;">本地時間 : </span>
									<span style="font-size: .71rem;">{{timeMess}} GMT+08:00</span>
									</div>
								<div class="tcDlViews" style="width: 100%;margin: .5rem 0;" @click="handgetdown">
									<div class="tcSpans" style="width: 100%;text-align: center;">
										<!-- <img src="../../image/icon_tuichu.png"> -->
										<img src="@/image/heardright/return.png">
										登出
									</div>
								</div>
								</a-collapse>
								</div>
						</div>
						</template>
					<div class="tcDlViews">
						<div class="tcSpans">
							<!-- <img src="../../image/icon_tuichu.png"> -->
							<img src="@/image/heardright/return.png">
							登出
						</div>
					</div>
			   </a-popover>
		</div>
		<getdown v-if='getdown == 3' @child='handgetdown'></getdown>
	</div>
</template>

<script>
	import App from '@/assets/app.js';
	import getdown from '../componhand/getdown.vue'
	export default {
		components:{getdown},
		data() {
			return {
				form:{
					realname:'',
					lastlogintime:'03/04/2021 12:12  GMT+08:00'
				},
				// 頂部mess
				timeMess: '',
				// 計數器
				timer: '',
				getdown:'',
				isshow:false,
				logoimg: require('@/image/simu/loleft.png'),
				imglist: [
					// require('@/image/simu/icon_t2.png'),
					// require('@/image/simu/icon_t3.png'),
					// require('@/image/simu/icon_t1.png'),
					{
						imgurl:require('@/image/heardright/icon1.png'),
						name:'首頁',
						widths:'calc(3.3rem)'
					},
					{
						imgurl:require('@/image/heardright/icon2.png'),
						name:'收件箱',
						widths:'calc(4rem)'
					},
					{
						imgurl:require('@/image/heardright/icon3.png'),
						name:'聯絡我們',
						widths:'calc(4.8rem)'
					},
					{
						imgurl:require('@/image/heardright/icon4.png'),
						name:'控制中心',
						widths:'calc(4.8rem)'
					},
					{
						imgurl:require('@/image/heardright/icon5.png'),
						name:'我的設定',
						width:'calc(4.8rem)'
					},
					{
						imgurl:require('@/image/heardright/times.png'),
						name:'如閒置超過30分鐘，基於安全理由您的帳戶將會自動登出。',
						widths:'calc(10rem + 22px)'
					}
				],
				tabledata: [{
						name: '恒生指數',
						num: '28000.41',
						numyellow: '1',
						static: 'down',
						downnum: '595.25',
						zero: '-2.08%'
					},
					{
						name: '蒽成交金額',
						num: '1593.02億',
					},
					{
						name: '國企指數',
						num: '10421.41',
						static: 'down',
						downnum: '229.25',
						zero: '-2.08%'
					},
					{
						name: '港中企業',
						num: '4112.41',
						static: '',
						downnum: '595.25',
						zero: '-2.08%'
					},
					{
						name: '金融分類',
						num: '38971.41',
						numyellow: '1',
						static: 'down',
						downnum: '705.25',
						zero: '-2.08%'
					},
					{
						name: '地產分類',
						num: '35406.41',
						static: 'down',
						downnum: '713.25',
						zero: '-2.08%'
					}
				],
				from: {
					time: '15.10.51',
					name: '到期提示'
				}
			}
		},
		mounted() {
			this.timeLoad()
			this.timeMake()
		},
		methods: {
			timeLoad() {
				let _this = this;
				let date = new Date();
				let s = date.getSeconds();
				clearTimeout(_this.timer);
				setInterval(() => {
					_this.timeMake();
					_this.timer = setTimeout(() => {
						_this.timeMake();
					}, 60 * 1000)
				}, s * 1000);
			},
			timeMake() {
				let _this = this;
				let date = new Date();
				_this.timeMess = App.oMath._zeroCompletion(date.getDate()) + '/' + App.oMath._zeroCompletion(date
						.getMonth() + 1) + '/' + date.getFullYear() +
					' ' + App.oMath._zeroCompletion(date.getHours()) + ':' + App.oMath._zeroCompletion(date.getMinutes());
				// _this.timeMess = date.getFullYear() + '.' + App.oMath._zeroCompletion(date.getMonth() + 1) + '.' + App.oMath._zeroCompletion(date.getDate()) 
				//                 + ' ' + App.oMath._zeroCompletion(date.getHours()) + ':' + App.oMath._zeroCompletion(date.getMinutes());
			},
			//第二操作
			shEvent() {
				this.$ajax({
					url:this.$api.getUserMsg,
					method:'post',
					data:{
						token:this.$store.state.token
					}
				}).then(res=>{
					if (res.data.qmiscode === 1000) {
						this.form.realname = res.data.realname
						this.form.lastlogintime = res.data.lastlogintime
					}
				})
				// if (this.shShowBol) {
					this.isshow = !this.isshow
				// } else {
					
				// }
			},
			handgetdown(){
				localStorage.clear()
				this.$router.push({
					path: '/'
				});
				// this.$router.go(-1)
				// this.getdown = ''
			},
			handadmin(ind){
				if(ind == 0){
					this.$router.go(-1)
				}
				if(ind == 3){
					// this.getdown = 3
				}
			}
		}
	}
</script>

<style lang='scss'>
	.warp-titlesui {
		color: #959595;
		display: inline-block;
		font-size: 1.1rem !important;
	}

	.warp-font {
		color: #f7d72b;
		font-size: 1.1rem !important;
	}

	.dingace {
		color: #ff0101;
		font-size: 1.1rem !important;
	}
	.my_back {
		.ant-popover-inner{
			    box-shadow: 0 2px 20px rgba(0, 0, 0, 0.15);
		}
	}
	.morediv{
		.ant-popover-inner-content{
			/* padding:0 !important; */
		}
	}
</style>
<style lang="scss" scoped>
	.tcDlViews{
	    cursor: pointer;
	}
	 .tcSpans{
	    display: flex;
	    align-items: center;
		margin-right: .6rem;
		background-color: #0c8b97;
		color: #fff;
		padding: .3rem .8rem;
		border-radius: 6px;
	    justify-content:flex-end;
	}
	
	 .tcSpans img{
	    width:1.3rem;
	    height:1rem;
	    margin-right:0.2rem;
	}
	.my_back {
		padding: .3rem;
		overflow: hidden;
		background-color: #fff;
	}
	.my_back div{
		display: inline-block;
	}
</style>
